import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { queryClient } from '../../../App'
import { getNewServiceOrders } from '../../../services/NewApiService'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'

export type ParamsType = {
  id?: string
  phoneNumber?: string
  dateOfMaintenanceFrom?: string
  dateOfMaintenanceTo?: string
  fullName?: string
  fullAddress?: string
  statuses: number[]
  dataCheckingStatuses: number[]
  ticketStatuses: number[]
  isBinded: boolean
  negativeIncidentTypeId: number[]
}

export const initParams: ParamsType = {
  statuses: [6],
  dataCheckingStatuses: [0, 3],
  ticketStatuses: [5, 2],
  isBinded: true,
  negativeIncidentTypeId: [3],
}

export const createMaintenanceReportPaginationStore = new NewPaginationStore(
  initParams,
)

export const createMaintenanceReportCheckboxStore = new CheckboxStore()

export const useCreateServiceReportTableData = () => {
  const {
    page,
    size,
    sort,
    params: {
      fullAddress,
      dateOfMaintenanceFrom,
      dateOfMaintenanceTo,
      fullName,
      id,
      phoneNumber,
      statuses,
      dataCheckingStatuses,
      ticketStatuses,
      isBinded,
      negativeIncidentTypeId,
    },
  } = createMaintenanceReportPaginationStore

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        'create-service-report-table',
        size,
        page,
        sort,
        fullAddress,
        dateOfMaintenanceFrom,
        dateOfMaintenanceTo,
        fullName,
        id,
        phoneNumber,
        statuses,
        dataCheckingStatuses,
        ticketStatuses,
        isBinded,
        negativeIncidentTypeId,
        userId,
      ],
      queryFn: () =>
        getNewServiceOrders({
          size,
          page,
          fullAddress,
          dateOfMaintenanceFrom,
          dateOfMaintenanceTo,
          fullName,
          id,
          phoneNumber,
          statuses,
          isBinded,
          sort: sort ?? undefined,
          dataCheckingStatuses,
          ticketStatuses,
          negativeIncidentTypeId,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId,
    },
    queryClient,
  )
}
